module.exports = __webpack_public_path__ + "img/visa.8c58d21e.svg";